export default "__VITE_ASSET__BqpxxblK__"